import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmKbRequestsReports2Route: InvariantJiraRoute = {
	name: 'csm-kb-requests-reports',
	path: '/jira/customer-service-management/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)',
};
